export const TYPE_GOOGLE = 'gmail';
export const TYPE_FACEBOOK = 'facebook';
export const LOADING_NAME = 'loading...';
export const LOADING_EMAIL = 'loading...';
export const PROFILE_LOADING = { name: LOADING_NAME, email: LOADING_EMAIL, image: '' };
